/* import __COLOCATED_TEMPLATE__ from './variant-selector.hbs'; */
import Component from '@ember/component';
import { computed, action } from '@ember/object';
import Constants from '../utils/constants';

import snakeCase from 'lodash.snakecase';

export default class VariantSelector extends Component {
    tagName = '';

    variantModalBodyArgs = {};

    showVariants = {};

    @action onVariantSelectorChange(variantCode) {
        // This should automatically update the model variables

        if (this.selectedItem.variants) {
            if (variantCode in this.showVariants)
                this.set(`showVariants.${variantCode}`, !this.showVariants[variantCode]);
            else this.set(`showVariants.${variantCode}`, true);

            this.set(
                'showVariant',
                Object.values(this.showVariants).some((value) => value),
            );
        } else this.set('showVariant', !this.showVariant);

        if (this.onVariantChange) this.onVariantChange(variantCode);
    }

    @computed('selectedItem.variants.@each.{code,display}', 'showVariants') get variants() {
        if (this.selectedItem.variants) {
            return this.selectedItem.variants.map((variant) => {
                return {
                    inputId: `${variant.code}-${this.inputId}`,
                    code: variant.code,
                    inputDisplay: variant.display,
                    checked: variant.code in this.showVariants ? this.showVariants[variant.code] : false,
                    qaAttrValue: `${Constants.QA_ATTR_PREFIX}_enable_${snakeCase(
                        variant.display.toLowerCase(),
                    )}_mode_cb`,
                    modalBodyArgs: Object.assign(
                        {},
                        this.variantModalBodyArgs,
                        variant.code in this.bodyArgsByVariant ? this.bodyArgsByVariant[variant.code] : {},
                    ),
                };
            });
        } else return null;
    }

    @computed('selectedItem.variant.code') get modalName() {
        let variant = this.selectedItem.variant;
        return variant ? variant.code : null;
    }

    @computed('selectedItem.variant.display') get inputDisplay() {
        let variant = this.selectedItem.variant;
        return variant ? variant.display : null;
    }

    @computed('selectedItem.variant.display') get qaAttrValue() {
        let variant = this.selectedItem.variant;
        if (variant) {
            let value = snakeCase(variant.display.toLowerCase());
            return `${Constants.QA_ATTR_PREFIX}_enable_${value}_mode_cb`;
        } else {
            return null;
        }
    }

    @computed('variantModelBodyArgs.lastUpdateDate', 'selectedItem.variant.code', 'bodyArgsByVariant.lastUpdateDate')
    get modalBodyArgs() {
        let code = this.selectedItem.variant ? this.selectedItem.variant.code : null;
        return code
            ? Object.assign(
                  {},
                  this.variantModalBodyArgs,
                  this.bodyArgsByVariant && code in this.bodyArgsByVariant ? this.bodyArgsByVariant[code] : {},
              )
            : {};
    }
}
